<template>
  <div class="container">
    <van-nav-bar
      title="用户余额转移"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="box">
      <van-field label-width="110" center label="当前手机号码" type="tel" v-model="oldMobile" placeholder="请输入当前手机号码" />
      <van-field label-width="110" center readonly label="当前账户余额(元)" v-model="khInfo.totalAmount">
        <template #button>
            <van-button size="small" type="info" @click="checkAmount">查询余额</van-button>
        </template>
      </van-field>
      <van-field label-width="110" center label="目标手机号码" type="tel" v-model="newMobile" placeholder="请输入目标手机号码" />
      <van-field label-width="110" center readonly label="转移金额(元)" v-model="khInfo.totalAmount" />
      
      <div class="pbox">
        <van-button block round :disabled="!khInfo.totalAmount" type="info" @click="transferPhone" >确定</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {NavBar,Icon,Toast,Loading,Button,Field,Dialog} from 'vant';
  export default {
    data() {
      return {
        oldMobile:'',
        amount:'',
        newMobile:'',
        khInfo:{}
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Button.name]:Button,
      [Field.name]:Field,
      [Dialog.name]:Dialog,
    },
    methods: {
      changePage(url){
        this.$router.push({path: url+".html"})
      },
      onClickLeft() {
        this.$router.go(-1)
      },
      changeResult(type){
        this.khInfo.isIntention = type;
      },
      checkAmount(){
        this.khInfo.totalAmount = '';
        axios.get("/utils/getcardamount?mobile="+this.oldMobile,{}).then((res)=>{
          this.khInfo = res.data;
          this.khInfo.totalAmount = this.khInfo.totalAmount/100;
        })
      },
      transferPhone(){
        Dialog.confirm({
          title: '提示',
          message: '请确认目标手机号：'+this.newMobile,
        }).then(() => {
          // on confirm
          axios.get("/utils/transfermobile?sourceMobile="+this.oldMobile+"&targetMobile="+this.newMobile,{}).then((res)=>{
            if(res.isSuccess){
              Toast('转移成功');
              setTimeout(()=>{
                this.onClickLeft();
              },1500)
            }
          })
        }).catch(() => {
          // on cancel
        });
      },
    },
    computed:{
    },
    created () {
    },
    mounted () {},
    destroyed () {}
  }
</script>

<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #fff}
  .container{
    width: 100%;min-height: 100vh;letter-spacing:0px;background: #F0F4F7;
  }
  .box{
    width: 100%;
    padding-top: 16px;
    box-sizing: border-box;
  }
  .pbox{
    padding: 26px 100px;
  }
</style>
